<template>
  <div id="app">
    <header class="banner" />
    <FancyButton
      :status="status"
      :name="profile.displayName"
      @updateStatus="updateStatus"
    />
    <Statistics :userData="userData" v-if="userData" />
  </div>
</template>

<script>
import FancyButton from "./components/FancyButton";
import Statistics from "./components/Statistics";

import {
  getProfile,
  getLIFFInfo,
  close,
  sendMessages
} from "../utils/liffHelper";
import { db } from "../db";
import dayjs from "dayjs";

export default {
  name: "App",
  components: {
    FancyButton,
    Statistics
  },
  data() {
    return {
      profile: {},
      LIFFInfo: {},
      users: [],
      status: 0
    };
  },
  computed: {
    userData() {
      return this.users.find(item => item[".key"] === this.profile.userId);
    }
  },
  firebase: {
    users: db.ref("users")
  },
  async mounted() {
    try {
      this.profile = await getProfile();
      this.LIFFInfo = await getLIFFInfo();
    } catch (error) {
      alert("出錯了");
      close();
    }

    db.ref(`users/${this.profile.userId}/${dayjs().format("YYYY-MM-DD")}`).once(
      "value",
      snapshot => {
        this.status = snapshot.val();
      }
    );
  },
  methods: {
    updateStatus(status) {
      if (!this.profile.userId) return;
      const offset = dayjs().hour() === 0 ? -1 : 0; // 晚上12點 應該要被算在前一天

      if (status) {
        db.ref(`users/${this.profile.userId}`)
          .update({
            [dayjs()
              .add(offset, "day")
              .format("YYYY-MM-DD")]: 1
          })
          .then(() => {
            sendMessages("我要睡覺了");
            setTimeout(() => {
              close();
            }, 1200);
          });
      } else {
        db.ref(`users/${this.profile.userId}`)
          .update({
            [dayjs()
              .add(offset, "day")
              .format("YYYY-MM-DD")]: 0
          })
          .then(() => {
            sendMessages("我又不睡了");
            setTimeout(() => {
              close();
            }, 1200);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#app {
  height: 100vh;
  display: grid;
  grid-template-rows: 200px 1fr 1fr;
}

.banner {
  width: 100%;
  height: 200px;
  background-image: url("https://source.unsplash.com/375x200/?moon");
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 100px;
}
</style>
